export default {
	getConnectInvoices(state) {
		return state.ConnectInvoices;
	},
	getConnectInvoicesTotal(state) {
		return state.ConnectInvoicesTotal;
	},
	MisaIdInfo(state) {
		return state.MisaIdInfo;
	}
};
